"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bgWithDynamicForeground = void 0;
exports.bgWithDynamicForeground = [
    "backgroundNeutral",
    "backgroundPrimary",
    "backgroundCritical",
    "backgroundWarning",
    "backgroundPositive",
    "brand",
];
